import React from 'react';

import PropTypes from 'prop-types';
import TextArea from '@tds/core-text-area';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectStepsToReplicate = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        Max_500_Characters: max500Characters,
        labelStepsToReplicate,
        placeHolderStepsToReplicate
      }
    }
  } = locale === 'en-US' ? EN : FR;

  return (
    <div>
      <TextArea
        label={`${labelStepsToReplicate} *`}
        hint={max500Characters}
        hintPosition="below"
        value={fieldData.stepsToReplicate}
        placeholder={placeHolderStepsToReplicate}
        feedback={'stepsToReplicate' in formErrors ? 'error' : ''}
        error={
          'stepsToReplicate' in formErrors
            ? formErrors.stepsToReplicate.message
            : ''
        }
        onChange={({ target: { value } }) => {
          if (!value)
            setFormErrors({
              ...formErrors,
              stepsToReplicate: { message: 'Field is required' }
            });
          else if (value.length > 500)
            setFormErrors({
              ...formErrors,
              stepsToReplicate: { message: 'Maximum 500 characters allowed' }
            });
          else {
            const errors = { ...formErrors };
            delete errors.stepsToReplicate;
            setFormErrors({
              ...errors
            });
          }
          setFieldData(previousValue => ({
            ...previousValue,
            stepsToReplicate: value
          }));
        }}
      />
    </div>
  );
};

DefectStepsToReplicate.propTypes = {
  formErrors: PropTypes.shape({
    stepsToReplicate: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectStepsToReplicate;
